import * as logClient from "@classdojo/log-client";

// The only report of a request that got no response: neither transport sends these to Sentry, and
// the query client's handleError ignores them. Logged even for silentNetworkError requests, which
// skip only the toast. The query string and fragment are dropped here so no caller has to remember to.
// Kept apart from networkFailure.ts so the Sentry beforeSend filter can log without importing the toast UI.
export function logNetworkFailure(details: {
  method?: string;
  requestPath?: string;
  errorCode?: string;
  errorName: string;
  errorMessage?: string;
}) {
  void logClient.logMessage("WARN", "marketplace.network_error", {
    site: "marketplace",
    ...details,
    requestPath: details.requestPath?.replace(/[?#].*$/, ""),
  });
}
